// Simple authentication system for private access
const AUTH_USERS = [
  { email: 'admin@iheroes.org', password: 'SecurePass123!' },
  { email: 'user@iheroes.org', password: 'UserPass456!' }
];

class AuthService {
  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem('iheroes_user')) || null;
  }

  isAuthenticated() {
    return this.currentUser !== null;
  }

  getCurrentUser() {
    return this.currentUser;
  }

  async signIn(email, password) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 800));
    
    const user = AUTH_USERS.find(
      u => u.email === email && u.password === password
    );
    
    if (user) {
      this.currentUser = {
        email: user.email,
        name: user.email.split('@')[0],
        authenticated: true
      };
      localStorage.setItem('iheroes_user', JSON.stringify(this.currentUser));
      return this.currentUser;
    }
    
    throw new Error('Invalid email or password');
  }

  signOut() {
    this.currentUser = null;
    localStorage.removeItem('iheroes_user');
  }
}

export const auth = new AuthService();